// extracted by mini-css-extract-plugin
export default {"container":"RightArrowButton_container__u7BM6","visible":"RightArrowButton_visible__h+eZz","hidden":"RightArrowButton_hidden__iUyte"};